import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';

import { TooltipData } from '../models/tooltip.models';

export interface LocalizedStrings {
  name: string;
  earNumber: string;
  age: string;
  height: string;
  bcs: string;
  excludeButton: string;
  includeButton: string;
  individualMonitoringButton: string;
}

export interface ExcludeEvent {
  registrationNumber: string;
  isExcluded: boolean;
}

@Component({
  selector: 'cow-tooltip',
  templateUrl: './cow-tooltip.component.html',
  standalone: true,
  imports: [CommonModule, MatCheckbox, MatIconButton, MatButton, MatIcon],
})
export class CowTooltipComponent {
  @Input() data = signal<TooltipData | null>(null);
  @Input() localizedStrings = signal<LocalizedStrings | null>(null);
  @Input() showIndividualMonitoringButton = signal<boolean>(true);
  @Input() showExcludeFromAverageControl = signal<boolean>(true);
  @Output() exclude = new EventEmitter<ExcludeEvent>();
  @Output() viewIndividualMonitoring = new EventEmitter<string>();
  @Output() closeTooltip = new EventEmitter<void>();

  protected onExcludeChange($event: MatCheckboxChange) {
    const registrationNumber = this.data()?.registrationNumber;
    if (registrationNumber) {
      this.exclude.emit({
        registrationNumber: registrationNumber,
        isExcluded: $event.checked,
      });
    }
  }

  protected onClose() {
    this.closeTooltip.emit();
  }

  protected onViewIndividualMonitoring() {
    const cowId = this.data()?.cowId;
    if (cowId) {
      this.viewIndividualMonitoring.emit(cowId);
    }
  }
}
